import React from "react";
import About from "../Components/about/About";
import TopBar from "../Components/common/TopBar";
import Spacer2 from "../Components/common/Spacer2";

function AboutPage() {
  return (
    <>
      <TopBar />
      <Spacer2/>
      <About />
    </>
  );
}

export default AboutPage;
